import axios from "axios"

export default {
    Vault:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? `/api/vaultoperations/vault/update` : `/api/vaultoperations/vault/create`,data)
            return response
        },
        async TreeList(){
            const response = await axios.get(`/api/vaultoperations/vault/list/tree`)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/vaultoperations/vault/delete/${data}`)
            return response
        },
        async PaymentModule(){
            const response = await axios.get(`/api/vaultoperations/vault/list/paymentmodule`)
            return response
        },
        async SetPaidPaymentTable(data){
            const response = await axios.post(`/api/vaultoperations/vault/list/setpaidpaymenttable`,data)
            return response
        },
        async CreateTransactionBatch(data){
            const response = await axios.post(`/api/vaultoperations/vault/transaction/batch/create`,data)
            return response
        },
        async GetTransactionBatchList(filters){
            const response = await axios.get(`/api/vaultoperations/vault/transaction/batch/list`, { params: filters })
            return response
        },
        async GetTransactionBatchDetail(masterId){
            const response = await axios.get(`/api/vaultoperations/vault/transaction/batch/detail/${masterId}`)
            return response
        }

    }
}